export default __webpack_public_path__ + "static/media/ab-img2.f1232385.png";